import type { RoomView } from "../game/types";

const STATS_KEY = "chin:stats:v1";

export interface PlayerStats {
  matches: number;
  wins: number;
  losses: number;
  draws: number;
  chins: number;
  falseChins: number;
  streak: number;
  bestStreak: number;
  lastMatchKey: string | null;
}

const EMPTY_STATS: PlayerStats = {
  matches: 0,
  wins: 0,
  losses: 0,
  draws: 0,
  chins: 0,
  falseChins: 0,
  streak: 0,
  bestStreak: 0,
  lastMatchKey: null,
};

export function readStats(): PlayerStats {
  try {
    const raw = localStorage.getItem(STATS_KEY);
    if (!raw) return { ...EMPTY_STATS };
    return { ...EMPTY_STATS, ...(JSON.parse(raw) as Partial<PlayerStats>) };
  } catch {
    return { ...EMPTY_STATS };
  }
}

function writeStats(stats: PlayerStats): void {
  try {
    localStorage.setItem(STATS_KEY, JSON.stringify(stats));
  } catch {
    // Sin storage no hay historial, pero la partida sigue.
  }
}

/** Acumula el resultado de una partida terminada, una sola vez por partida. */
export function recordMatch(room: RoomView): void {
  if (room.phase !== "finished") return;
  const self = room.players.find((player) => player.id === room.selfId);
  if (!self) return;

  const matchKey = `${room.code}:${room.lastEvent?.at ?? 0}`;
  const stats = readStats();
  if (stats.lastMatchKey === matchKey) return;

  stats.lastMatchKey = matchKey;
  stats.matches += 1;
  stats.chins += self.chinCount;
  stats.falseChins += self.falseChinCount;

  if (room.winnerId === null) {
    stats.draws += 1;
  } else if (room.winnerId === room.selfId) {
    stats.wins += 1;
    stats.streak += 1;
    stats.bestStreak = Math.max(stats.bestStreak, stats.streak);
  } else {
    stats.losses += 1;
    stats.streak = 0;
  }

  writeStats(stats);
}
